import React, { Fragment } from 'react';
import DaumPostcodeEmbed, { Address } from 'react-daum-postcode';
import Modal from '../Modal';
import Button from '../Button';
import './SearchAddress.scss';

interface SearchAddressProps {
  isEditable?: boolean;
  address: { postCode: string; line1: string };
  onSelect: (data: { city: string; postCode: string; line1: string }) => void;
}

const SearchAddress = (props: SearchAddressProps): JSX.Element => {
  const { onSelect, address, isEditable = true } = props;
  const { postCode, line1 } = address;
  const [isAddressModalOpen, setIsAddressModalOpen] = React.useState(false);

  const toggleModal = (): void => setIsAddressModalOpen(!isAddressModalOpen);

  const handleSelect = (data: Address): void => {
    setIsAddressModalOpen(false);

    onSelect({
      city: data.sido,
      postCode: data.zonecode ? data.zonecode : '',
      line1: data.roadAddress ? data.roadAddress : data.jibunAddress,
    });
  };

  return (
    <Fragment>
      <Modal
        title="주소 검색"
        onClose={toggleModal}
        isOpen={isAddressModalOpen}
        width={610}
        height={500}
        isFooter={false}
      >
        {isAddressModalOpen ? (
          <DaumPostcodeEmbed animation={true} style={{ height: '100%' }} onComplete={handleSelect} />
        ) : null}
      </Modal>

      {/**/}
      <div className={isEditable ? 'search-address-info' : ''}>
        {postCode && line1 ? (
          <span>
            ({postCode}) {line1}
          </span>
        ) : null}
      </div>

      {/* 주소 검색을 하는 모달을 열고 닫는 버튼*/}
      {isEditable ? (
        <Button
          className="search-address-btn"
          type="button"
          isRadius={true}
          color="primary"
          disabled={!isEditable}
          text="주소 검색"
          onClick={toggleModal}
        />
      ) : null}
    </Fragment>
  );
};

export default SearchAddress;
